import { render, staticRenderFns } from "./Area7.vue?vue&type=template&id=0c45cf5f&scoped=true&"
import script from "./Area7.vue?vue&type=script&lang=js&"
export * from "./Area7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c45cf5f",
  null
  
)

export default component.exports